import React from "react";
// import { ArrowIcon, ArchiveIcon, LogoutIcon, ProfileIcon } from "../../images";
// import constant from "./utils/constant";
import PropTypes from "prop-types";
// import useMediaQuery from "./hooks/useMediaQuery";

const Header = (props) => {
  const { classNames } = props;
  // const [isOpen, handleToggle] = useState(false);
  // const isDesktop = useMediaQuery("(min-width: 830px)");

  // const _handleLogout = () => {
  //   window.location.href = constant.API.LOGOUT_URL;
  //   //note: when send request to logout, no need to remove 'sessionid' from cookies, django in backend removes it.
  // };

  return (
    <div className={classNames}>
      <div className='title'>
        <div className='main-title'>تبدیل گفتار به متن حرفـــــ</div>
        <div className='in-web'>
          <div>حرف با استفاده از هزاران ساعت گفتار با صدای افراد مختلف،</div>
          <div>
            زبان فارسی را یاد گرفته است و می‌تواند متن صحبت‌ها را بنویسد.
          </div>
        </div>
        <div className='in-mobile'>
          <div>حرف، زبان فارسی را یاد گرفته است</div>
          <div>و می‌تواند متن صحبت‌ها را بنویسد.</div>
        </div>
      </div>
      {/* <div className={"logout-section " + (isOpen ? "open" : "")}>
        <div className="user-wrapper" onClick={() => handleToggle(!isOpen)}>
          <div className="user">
            <ProfileIcon className="profile-icon" />
            <div>{constant.API.USER_NAME}</div>
            <ArrowIcon className="arrow-icon" />
          </div>
        </div>
        {isOpen && (
          <div className="logout" onClick={_handleLogout}>
            <LogoutIcon />
            <span>خروج</span>
          </div>
        )}
      </div> */}
    </div>
  );
};

Header.propTypes = {
  classNames: PropTypes.string,
};

// Set default props
Header.defaultProps = {
  classNames: "",
};

export default Header;
